import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const TradeChartScreen = () => {
  const { metal } = useParams(); // Get metal from URL
  const navigate = useNavigate();
  
  const [volume, setVolume] = useState('');
  const [lot, setLot] = useState(1);
  const [tradeType, setTradeType] = useState('');
  const [rate, setRate] = useState();
  const [loading, setLoading] = useState(true);
  const [high, setHigh] = useState();
  const [open, setOpen] = useState();
  const [low, setLow] = useState();
  const [target, setTarget] = useState('');
  const [stoploss, setStoploss] = useState('');
  const [limit, setLimit] = useState('');
  const [balance, setBalance] = useState();
  const [name, setName] = useState('');
  const [userId, setUserId] = useState('');
  // Initialize chart
  

  // Fetch real-time data
  useEffect(() => {
    if (!metal) return;

    const fetchMetalData = () => {
      fetch(`https://easycomm.in/Rest3/metal_api/${metal}`)
        .then(response => response.json())
        .then(data => {
          setRate(data.rate);
          setOpen(data.open);
          setHigh(data.high);
          setLow(data.low);
          setLot(data.lots || 1);
          setLoading(false);
          
         
        })
        .catch(error => {
          console.error('Error fetching metal data:', error);
          setLoading(false);
        });
    };

    // Initial fetch
    fetchMetalData();
    
    // Set interval for live updates
    const interval = setInterval(fetchMetalData, 2000);
    
    return () => clearInterval(interval);
  }, [metal]);

  // Fetch user data
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const uid = localStorage.getItem("userid");
        const name = localStorage.getItem("name");
        setName(name || '');
        setUserId(uid || '');

        if (uid) {
          const response = await fetch(`https://easycomm.in/Rest3/wallet_api/${uid}`);
          const data = await response.json();
          setBalance(data.wallet || '0.00');
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []);

  const handleSubmit = async () => {
    if (!volume || volume <= 0) {
      alert("Please enter lot size");
      return false;
    }
    
    let target1 = target;
    let stoploss1 = stoploss;
    
    if (tradeType === "BUY") {
      if (!target1) target1 = 100000;
      if (!stoploss1) stoploss1 = 0;
    } 
    if (tradeType === "SELL") {
      if (!target1) target1 = 0;
      if (!stoploss1) stoploss1 = 100000;
    }
    
    setLoading(true);
    const userid = localStorage.getItem("userid");
    
    // Using FormData for submission
    const formData = new FormData();
    formData.append('userid', userid);
    formData.append('metal', metal);
    formData.append('lot', lot);
    formData.append('rate', rate);
    formData.append('lotsize', volume);
    formData.append('btype', tradeType);
    formData.append('market_type', "MCX");
    formData.append('target', target1);
    formData.append('stoploss', stoploss1);
    formData.append('setlimit', limit);
    formData.append('market', "true");

    try {
      const response = await fetch('https://easycomm.in/Rest3/web_app_start_trade/', {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();
      console.log(result);
      
      alert(result.msg);
      
      if (result.status === 1) {
        navigate('/tradelist');
      }
    } catch (error) {
      console.error('Trade submission error:', error);
      alert('Failed to submit trade. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Alternative using URLSearchParams
  const handleSubmitURLEncoded = async () => {
    if (!volume || volume <= 0) {
      alert("Please enter lot size");
      return false;
    }
    
    let target1 = target;
    let stoploss1 = stoploss;
    
    if (tradeType === "BUY") {
      if (!target1) target1 = 100000;
      if (!stoploss1) stoploss1 = 0;
    } 
    if (tradeType === "SELL") {
      if (!target1) target1 = 0;
      if (!stoploss1) stoploss1 = 100000;
    }
    
    setLoading(true);
    const userid = localStorage.getItem("userid");
    
    const formData = new URLSearchParams();
    formData.append('userid', userid);
    formData.append('metal', metal);
    formData.append('lot', lot);
    formData.append('rate', rate);
    formData.append('lotsize', volume);
    formData.append('btype', tradeType);
    formData.append('market_type', "MCX");
    formData.append('target', target1);
    formData.append('stoploss', stoploss1);
    formData.append('setlimit', limit);
    formData.append('market', "true");

    try {
      const response = await fetch('https://easycomm.in/Rest3/app_start_trade/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      const result = await response.json();
      console.log(result);
      
      alert(result.msg);
      
      if (result.status === 1) {
        navigate('/tradelist');
      }
    } catch (error) {
      console.error('Trade submission error:', error);
      alert('Failed to submit trade. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const timeFilters = ['15m', '1h', '4h', '1d', '1w', '1m', '3m', '1y'];
  const [activeTimeFilter, setActiveTimeFilter] = useState('1d');

  if (loading) {
    return (
      <div className="min-vh-100 d-flex justify-content-center align-items-center bg-light">
        <div className="text-center">
          <div className="spinner-border text-success mb-3" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-success">Loading {metal} data...</p>
        </div>
      </div>
    );
  }

  if (!metal) {
    return (
      <div className="min-vh-100 d-flex justify-content-center align-items-center bg-light">
        <div className="text-center">
          <div className="alert alert-warning mb-3">
            <i className="bi bi-exclamation-triangle me-2"></i>
            No metal selected
          </div>
          <button className="btn btn-success" onClick={() => navigate(-1)}>
            Go Back
          </button>
        </div>
      </div>
    );
  }

  const priceChange = rate && open ? ((rate - open) / open * 100).toFixed(2) : 0;
  const priceChangeValue = rate && open ? (rate - open).toFixed(2) : 0;
  const isPositive = priceChange >= 0;

  return (
    <div className="min-vh-100 bg-light">
      {/* Header */}
      <div className="bg-white border-bottom shadow-sm py-3">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <button 
              className="btn btn-outline-secondary btn-sm rounded-circle p-2"
              onClick={() => navigate(-1)}
            >
              <i className="bi bi-arrow-left"></i>
            </button>
            
            <div className="d-flex align-items-center">
              <span className="badge bg-success bg-opacity-10 text-success py-2 px-3 rounded-pill">
                <i className="bi bi-coin me-2"></i>
                {metal}
              </span>
            </div>
            
            <div className="text-muted small">
              ID: #{userId ? userId.slice(-4) : '----'}
            </div>
          </div>
        </div>
      </div>

      <div className="container py-4">
        {!tradeType && (
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <h4 className="fw-bold text-dark mb-1">₹{rate || '0.00'}</h4>
                  <span className={`badge ${isPositive ? 'bg-success' : 'bg-danger'} bg-opacity-10 ${isPositive ? 'text-success' : 'text-danger'}`}>
                    <i className={`bi ${isPositive ? 'bi-arrow-up' : 'bi-arrow-down'} me-1`}></i>
                    {isPositive ? '+' : ''}{priceChange}% (₹{priceChangeValue})
                  </span>
                </div>
                <div className="dropdown">
                  <button className="btn btn-outline-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown">
                    Today
                  </button>
                  <ul className="dropdown-menu">
                    <li><button className="dropdown-item">Today</button></li>
                    <li><button className="dropdown-item">This Week</button></li>
                    <li><button className="dropdown-item">This Month</button></li>
                  </ul>
                </div>
              </div>

              {/* Chart */}
              
            </div>
          </div>
        )}

        {/* Time Filters */}
        

        {/* Price Details Card */}
        <div className="card border-0 shadow-sm mb-4">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div>
                <h5 className="fw-bold text-dark mb-1">{metal}</h5>
                <small className="text-muted">MCX</small>
              </div>
              <div className="text-end">
                <h4 className="fw-bold text-dark mb-1">₹{rate || '0.00'}</h4>
                <span className={`badge ${isPositive ? 'bg-success' : 'bg-danger'} bg-opacity-10 ${isPositive ? 'text-success' : 'text-danger'}`}>
                  {isPositive ? '+' : ''}{priceChange}%
                </span>
              </div>
            </div>

            <div className="row border-bottom pb-3 mb-3">
              <div className="col-4 text-center">
                <small className="text-muted d-block">High</small>
                <span className="fw-semibold text-success">₹{high || '0.00'}</span>
              </div>
              <div className="col-4 text-center">
                <small className="text-muted d-block">Low</small>
                <span className="fw-semibold text-danger">₹{low || '0.00'}</span>
              </div>
              <div className="col-4 text-center">
                <small className="text-muted d-block">Open</small>
                <span className="fw-semibold">₹{open || '0.00'}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Trade Form */}
        {tradeType && (
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">
              <h6 className="fw-bold mb-4">Enter Trade Details</h6>
              
              <div className="mb-3">
                <label className="form-label small fw-semibold">
                  Enter No of Lots to {tradeType.toUpperCase()}
                </label>
                <input
                  type="number"
                  className="form-control form-control-lg text-center"
                  value={volume}
                  onChange={(e) => setVolume(e.target.value)}
                  placeholder="Enter lot size"
                />
              </div>

              <div className="row mb-4">
                <div className="col-6">
                  <label className="form-label small fw-semibold">TARGET</label>
                  <input
                    type="number"
                    className="form-control text-center"
                    value={target}
                    onChange={(e) => setTarget(e.target.value)}
                    placeholder="Target price"
                  />
                </div>
                <div className="col-6">
                  <label className="form-label small fw-semibold">STOPLOSS</label>
                  <input
                    type="number"
                    className="form-control text-center"
                    value={stoploss}
                    onChange={(e) => setStoploss(e.target.value)}
                    placeholder="Stop loss price"
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Buy/Sell Buttons */}
        <div className="row g-3">
          {!tradeType ? (
            <>
              <div className="col-6">
                <button
                  className="btn btn-danger w-100 py-3 fw-bold"
                  onClick={() => setTradeType('SELL')}
                >
                  <div>SELL</div>
                  <small className="opacity-75">₹{rate || '0.00'}</small>
                </button>
              </div>
              <div className="col-6">
                <button
                  className="btn btn-success w-100 py-3 fw-bold"
                  onClick={() => setTradeType('BUY')}
                >
                  <div>BUY</div>
                  <small className="opacity-75">₹{rate || '0.00'}</small>
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="col-6">
                <button
                  className="btn btn-outline-secondary w-100 py-3 fw-bold"
                  onClick={() => setTradeType('')}
                >
                  CANCEL
                </button>
              </div>
              <div className="col-6">
                <button
                  className={`btn w-100 py-3 fw-bold ${tradeType === 'BUY' ? 'btn-success' : 'btn-danger'}`}
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Processing...
                    </>
                  ) : (
                    `SUBMIT ${tradeType}`
                  )}
                </button>
              </div>
            </>
          )}
        </div>

      </div>
    </div>
  );
};

export default TradeChartScreen;